import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '../services/auth.service';

export const authGuard: CanActivateFn = (route, state) => {
    const authService = inject(AuthService);
    const router = inject(Router);

    if (authService.isAuthenticated) {
        // Check for required roles
        const requiredRoles = route.data['roles'] as Array<string>;
        if (requiredRoles) {
            const userRole = authService.getUserRole();
            if (userRole && requiredRoles.includes(userRole)) {
                return true;
            }

            // Redirect unauthorized users
            return router.createUrlTree(['/login']);
        }
        return true;
    }

    // Redirect to login page
    return router.createUrlTree(['/login']);
};
